import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../src/servicios/supabase-funciones";
import './login.css';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMensaje("");

    try {
      const { data, error } = await login(email, password);

      if (error) {
        setMensaje("❌ Error al iniciar sesión: " + error.message);
      } else {
        setMensaje("✅ Inicio de sesión exitoso");
        setTimeout(() => {
          navigate("/"); // redirige al home
        }, 1000);
      }
    } catch (error) {
      setMensaje("❌ Error inesperado: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Iniciar Sesión</h2>
        
        <label>
          Usuario:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            required
            disabled={isLoading}
          />
        </label>

        <label>
          Contraseña:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            disabled={isLoading}
          />
        </label>

        <button 
          type="submit" 
          className={isLoading ? 'loading' : ''}
          disabled={isLoading}
        >
          {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
        </button>
      </form>

      {mensaje && (
        <p style={{
          textAlign: 'center',
          padding: '1rem',
          borderRadius: '8px',
          fontWeight: '600',
          marginTop: '1.5rem',
          backgroundColor: mensaje.includes('❌') ? '#FEF2F2' : '#F0FDF4',
          border: `1px solid ${mensaje.includes('❌') ? '#DC2626' : '#059669'}`,
          color: mensaje.includes('❌') ? '#DC2626' : '#059669'
        }}>
          {mensaje}
        </p>
      )}
    </div>
  );
}